<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<nz-header>
  <div class="w-100">
    <div class="row justify-content-between align-items-center">
      <div class="header-left" [style.max-width]="collapsed() ? '120px' : '250px'">
        <div class="header-logo mr-2">
          <a [routerLink]="['/']">
            <img alt="logo" [src]="logoPath" [style.width]="collapsed() ? '100px' : '120px'" />
          </a>
        </div>
        <span class="header-trigger" (click)="changeCollapse()">
          <i class="trigger" nz-icon [nzType]="collapsed() ? 'double-right' : 'double-left'"></i>
        </span>
      </div>

      <div class="header-right">
        <div class="header-content d-flex justify-content-end align-items-center">
          <race-language-selection />
          <div class="notification separate">
            <nz-badge class="header-badge" [nzCount]="notificationService.notificationCount()" (click)="open()">
              <span class="icon-dot" nzPlacement="bottomRight">
                <i class="fs-20 icon-primary" nz-icon nzTheme="outline" nzType="bell"></i>
              </span>
            </nz-badge>
          </div>
          @if (roles() && roles().length) {
            <div class="separate d-none d-sm-block text-nowrap">
              <span
                class="mx-2"
                nz-dropdown
                nzTrigger="click"
                style="cursor: pointer; border: dashed 0.5px #afabab; border-radius: 5px; padding: 5px 10px"
                [nzDropdownMenu]="(roles()?.length ?? 0) > 1 ? switchRole : null"
              >
                {{ selectedRoleName }}
                @if ((roles()?.length ?? 0) > 1) {
                  <i nz-icon nzType="down" style="position: relative; top: 2px"></i>
                }
              </span>
              <nz-dropdown-menu #switchRole="nzDropdownMenu">
                <ul nz-menu>
                  @for (role of roles(); track role; let i = $index) {
                    <li nz-menu-item (click)="changeRole(role.id, role.name)">
                      {{ role?.name }}
                      @if (+selectedRoleId === role.id) {
                        <i class="icon-primary" nz-icon nzTheme="outline" nzType="check"></i>
                      }
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>
            </div>
          }
          @if (user()) {
            <div
              class="user-profile position-relative"
              nz-dropdown
              nzPlacement="bottomRight"
              nzTrigger="click"
              [nzDropdownMenu]="menu"
            >
              <div class="profile-img">
                @if (profileImage()) {
                  <img
                    class="profile-img-avatar"
                    [alt]="(userService.user().fullName || 'User') + ' profile picture'"
                    [src]="profileImage()"
                    (error)="onProfileImageError()"
                  />
                } @else {
                  <span class="icon-primary" nz-icon nzTheme="outline" nzType="user"></span>
                }
              </div>
              <div class="profile lh-normal pl-2">
                <div class="username text-right">
                  <span
                    class="username d-block lh-normal gray-900-text"
                    nz-tooltip
                    [nzTooltipTitle]="userService.user().username"
                  >
                    {{ userService.user().fullName || "userName" }}
                  </span>
                </div>
              </div>
            </div>
          }

          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item [routerLink]="['/profile']">
                {{ "profile_myProfile" | translate }}
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="logout()">
                {{ "header_logout" | translate }}
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </div>
  </div>
</nz-header>
<nz-drawer
  nzPlacement="right"
  nzWidth="min(100vw, 378px)"
  [nzClosable]="true"
  [nzFooter]="footerTpl"
  [nzTitle]="'notificationList.title' | translate"
  [nzVisible]="visible"
  (nzOnClose)="close(true)"
>
  <ng-container *nzDrawerContent>
    <race-notification-content [isLoading]="isDrawerLoading" (closeDrawer)="close($event)" />
  </ng-container>
  <ng-template #footerTpl>
    <div class="notification-footer no-gutters d-flex">
      <div class="col-12">
        <a
          class="d-inline-block py-3 px-2 w-100 text-white br-white"
          [routerLink]="['/notifications']"
          (click)="visible = false"
        >
          {{ "common_allNotifications" | translate }}
        </a>
      </div>
    </div>
  </ng-template>
</nz-drawer>
